import VideoCard from '@/components/base/VideoCard';
import { getHotVideos } from '@/mocks/videos';

export default function HotVideos() {
  const hotVideos = getHotVideos().slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              热门推荐
            </h2>
            <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary-100">
              <i className="ri-fire-fill text-primary-500 text-sm"></i>
              <span className="text-xs font-medium text-primary-700">HOT</span>
            </div>
          </div>
          <Link
            to="/category/dianying"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            更多热门 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hotVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}